import React from 'react'
import 'src/cases/cases.css'
import ResponsiveAppBar from 'src/common/ResponsiveAppBar'
import { CreateNewFolder as CreateNewFolderIcon } from '@mui/icons-material'

export default function Cases() {
  return (
    <>
      <ResponsiveAppBar title="Invoice Type" pageIcon={<CreateNewFolderIcon />} />
      <div className="cases-container">
        <div className="container">
          <div className="content">
            <h1 className="main-title">🚧 Website Under Construction 🚧</h1>
            <p className="description">
              Our team is building something amazing. Stay tuned, it's going to be worth
              the wait!
            </p>
            <p className="thank-you">Thank you for your patience!</p>
          </div>
        </div>
      </div>
    </>
  )
}
